import React from "react";
import { Store } from "../../service/Store";
import Lang from "../../service/Lang";
import { RouteComponentProps } from "react-router";
import { APIBase, Device, DeviceOutput } from "../../service/API";
import { arrowBack, reload } from "ionicons/icons";
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonLoading, IonPage, IonText, IonTitle, IonToolbar } from "@ionic/react";
import { inject } from "mobx-react";

import './Style.css';
enum ModbusLoraRegister {
    STATION_ADDRESS = 0x00,
    WRITE_STATION_CONFIG = 0x01,
    OUTPUT_LATCH = 0x02,
    OUTPUT_1 = 0x02,
    OUTPUT_2 = 0x03,
    OUTPUT_3 = 0x04,
    OUTPUT_4 = 0x05,
    OUTPUT_5 = 0x06,
    OUTPUT_6 = 0x07,
    RESERVED_108 = 0x08,
    RESERVED_109 = 0x09,
    WRITE_PULSE_COUNTER_COMMAND = 0x0A,
    WRITE_PULSE_COUNTER_HIGH_WORD = 0x0B,
    WRITE_PULSE_COUNTER_LOW_WORD = 0x0C,
    UNIX_TIME_H = 0x0D,
    UNIX_TIME_L = 0x0E,
    STATION_CONFIG = 0x0F,
    LATCH_OUTPUTS = 0x10,
    DIGITAL_INPUTS = 0x11,
    ANALOG_INPUT_1 = 0x12,
    ANALOG_INPUT_2 = 0x13,
    ANALOG_BATTERY_VOLTAGE = 0x14,
    COUNTER_1_H = 0x15,
    COUNTER_1_L = 0x16,
    COUNTER_2_H = 0x17,
    COUNTER_2_L = 0x18,
    COUNTER_3_H = 0x19,
    COUNTER_3_L = 0x1A,
    COUNTER_4_H = 0x1B,
    COUNTER_4_L = 0x1C,
    COUNTER_5_H = 0x1D,
    COUNTER_5_L = 0x1E,
    COUNTER_6_H = 0x1F,
    COUNTER_6_L = 0x20,
    PARTIAL_COUNTER_1 = 0x21,
    PARTIAL_COUNTER_2 = 0x22,
    PARTIAL_COUNTER_3 = 0x23,
    PARTIAL_COUNTER_4 = 0x24,
    PARTIAL_COUNTER_5 = 0x25,
    PARTIAL_COUNTER_6 = 0x26,
    TEMPERATURE = 0x27,
    HUMIDITY = 0x28
};

type StationData = {
    stationAddress: number,
    stationConfig: number,
    output1: number,
    output2: number,
    output3: number,
    output4: number,
    output5: number,
    output6: number,

    latchOutputs: number,
    digitalInputs: number,
    analogInput1: number,
    analogInput2: number,
    batteryVoltage: number,

    counter1: number,
    counter2: number,
    counter3: number,
    counter4: number,
    counter5: number,
    counter6: number,
    partial1: number,
    partial2: number,
    partial3: number,
    partial4: number,
    partial5: number,
    partial6: number,
    temperature: number,
}
export interface DeviceOutputServiceFSWifiProps extends RouteComponentProps<{ id: string, output: string }> {
    store?: Store;
    lang?: Lang;
    routerOutlet: HTMLIonRouterOutletElement,
}
export interface DeviceOutputServiceFSWifiState {
    device?: Device,
    output?: DeviceOutput,
    loading?: boolean,
    error?: string,
    stationsList?: { stationId: number, stationConfig: number, stationAddress: number, stationData?: StationData }[],

    stationConfig?: StationData
}


@inject("store", "lang")
export default class DeviceOutputServiceFSWifi extends React.Component<DeviceOutputServiceFSWifiProps, DeviceOutputServiceFSWifiState> {

    state: Readonly<DeviceOutputServiceFSWifiState> = {} as DeviceOutputServiceFSWifiState;



    componentDidMount(): void {
        let id = parseInt(this.props.match.params.id);
        this.loadDevice(id);
    }

    componentDidUpdate(prevProps: Readonly<DeviceOutputServiceFSWifiProps>, prevState: Readonly<DeviceOutputServiceFSWifiState>, snapshot?: any): void {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.loadDevice(parseInt(this.props.match.params.id));
        }

    }

    loadDevice(id: number) {
        this.props.store!.api.deviceGet(id, 'outputModbus').then((value: APIBase<Device>) => {
            if (value.success) {
                let output_id = parseInt(this.props.match.params.output);
                let output = value.data.outputs.find((a) => a.id === output_id);
                this.setState({ device: value.data, output: output }, () => {
                    if (output) {
                        if (output.outputService) {
                            this.updateCommand();
                        } else {
                            this.setState({ loading: false, error: 'No se ha configurado el servicio: No hay salida asociada' });
                        }
                    } else {
                        this.setState({ loading: false, error: 'Inposible obtener la salida' });
                    }
                });

            } else {
                this.setState({ loading: false, error: 'Inposible obtener la información' });
            }
        });
    }

    updateCommand() {
        this.queryModbus(16, 32).then((value: any) => {
            if (value.modbusResponse) {
                let array: number[] = value.modbusResponse;
                let results: any = [];
                for (let i = 0; i < 16; i++) {
                    let stationConfig = array[i * 2 + 0];
                    let stationAddress = array[i * 2 + 1];
                    let stationId = (i + 1);

                    results.push({
                        stationId: stationId,
                        stationConfig: stationConfig,
                        stationAddress: stationAddress,
                    });


                }
                this.setState({ loading: false, error: "", stationsList: results });

            } else {
                this.setState({ loading: false, error: 'Error la peticion: No hay respuesta modbus' });
                return;
            }

            console.log(value);
        }).catch((error: any) => {
            console.error(error);
            this.setState({ loading: false, error: 'Error al obtener los datos de la estación' });
        });

    }
    changeScreenCommand(screenId: number) {
        this.writeModbus(59, screenId).then((value: any) => {
            // @ts-ignore
            if (window.confirm("¿Desea recargar la pantalla?")) {
                this.updateCommand();
            }
        });

    }
    inputKey(key: number) {
        this.writeModbus(58, key).then((value: any) => {
            // @ts-ignore
            if (window.confirm("¿Desea recargar la pantalla?")) {
                this.updateCommand();
            }
        });

    }

    queryModbus(addr: number, size: number) {
        return new Promise((resolve, reject) => {
            let output = this.state.output as DeviceOutput;

            if (!output.modbusWrite) {

                this.setState({ loading: false, error: 'No se ha configurado el servicio: No hay funcion modbus de escritura.' });
                return;
            }
            let modbus = { ...output.modbusWrite };
            modbus.address = addr;
            modbus.registers = size;
            modbus.dataFormat = 1;
            modbus.functionCode = 3;

            this.setState({ loading: true, error: "" });

            this.props.store!.api.deviceModbusQuery(this.state.device!.id!, modbus).then((value: APIBase<any>) => {
                if (value.success) {
                    this.setState({ loading: false, error: "" });
                    resolve(value.data);
                } else {
                    this.setState({ loading: false, error: 'Inposible obtener la información' });
                }
            });
        });

    }
    writeModbus(addr: number, data: number) {
        return new Promise((resolve, reject) => {
            let output = this.state.output as DeviceOutput;

            if (!output.modbusRead) {

                this.setState({ loading: false, error: 'No se ha configurado el servicio: No hay funcion modbus de lectura.' });
                return;
            }
            let modbus = { ...output.modbusRead };
            modbus.address = addr;
            modbus.registers = 1;
            modbus.functionCode = 6;
            modbus.dataFormat = 1;
            modbus.value = data;

            this.setState({ loading: true, error: "" });

            this.props.store!.api.deviceModbusQuery(this.state.device!.id!, modbus).then((value: APIBase<any>) => {
                if (value.success) {
                    this.setState({ loading: false, error: "" });
                    resolve(value.data);
                } else {
                    this.setState({ loading: false, error: 'Inposible obtener la información' });
                }
            });
        });

    }

    parseModbusData(array: number[]) {
        return {
            stationAddress: array[ModbusLoraRegister.STATION_ADDRESS],
            stationConfig: array[ModbusLoraRegister.STATION_CONFIG],
            output1: array[ModbusLoraRegister.OUTPUT_1],
            output2: array[ModbusLoraRegister.OUTPUT_2],
            output3: array[ModbusLoraRegister.OUTPUT_3],
            output4: array[ModbusLoraRegister.OUTPUT_4],
            output5: array[ModbusLoraRegister.OUTPUT_5],
            output6: array[ModbusLoraRegister.OUTPUT_6],
            latchOutputs: array[ModbusLoraRegister.LATCH_OUTPUTS],
            digitalInputs: array[ModbusLoraRegister.DIGITAL_INPUTS],
            analogInput1: array[ModbusLoraRegister.ANALOG_INPUT_1],
            analogInput2: array[ModbusLoraRegister.ANALOG_INPUT_2],
            batteryVoltage: array[ModbusLoraRegister.ANALOG_BATTERY_VOLTAGE],
            counter1: (array[ModbusLoraRegister.COUNTER_1_H] << 16) | array[ModbusLoraRegister.COUNTER_1_L],
            counter2: (array[ModbusLoraRegister.COUNTER_2_H] << 16) | array[ModbusLoraRegister.COUNTER_2_L],
            counter3: (array[ModbusLoraRegister.COUNTER_3_H] << 16) | array[ModbusLoraRegister.COUNTER_3_L],
            counter4: (array[ModbusLoraRegister.COUNTER_4_H] << 16) | array[ModbusLoraRegister.COUNTER_4_L],
            counter5: (array[ModbusLoraRegister.COUNTER_5_H] << 16) | array[ModbusLoraRegister.COUNTER_5_L],
            counter6: (array[ModbusLoraRegister.COUNTER_6_H] << 16) | array[ModbusLoraRegister.COUNTER_6_L],
            partial1: array[ModbusLoraRegister.PARTIAL_COUNTER_1],
            partial2: array[ModbusLoraRegister.PARTIAL_COUNTER_2],
            partial3: array[ModbusLoraRegister.PARTIAL_COUNTER_3],
            partial4: array[ModbusLoraRegister.PARTIAL_COUNTER_4],
            partial5: array[ModbusLoraRegister.PARTIAL_COUNTER_5],
            partial6: array[ModbusLoraRegister.PARTIAL_COUNTER_6],
            temperature: array[ModbusLoraRegister.TEMPERATURE],
        }
    }

    handleCargarDatos = (stationId: number) => (ev: any) => {

        this.queryModbus((stationId * 0x100), 64).then((data: any) => {
            if (data && data.modbusResponse) {
                let array: number[] = data.modbusResponse;
                let stationConfig = this.state.stationsList?.find((s) => s.stationId === stationId);
                if(stationConfig) {
                    stationConfig.stationData = this.parseModbusData(array);
                }
                this.setState({ loading: false, error: "" });
                // Handle the data received from the API
            } else {
                this.setState({ loading: false, error: 'Inposible obtener la información' });
            }
        });
    };
    renderLoading() {
        // const { lang } = this.props;
        return <IonLoading
            isOpen={this.state.loading!}
            message={"Descargando datos de estacion..."}
        />
    }

    renderStationData(stationData: StationData) {
        return <div>
            <table>
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Valor</th>
                        <th>Modbus</th>
                    </tr>
                </thead>
                <tbody className="station-table-body">
                    <tr>
                        <th>Dirección</th>
                        <td>{stationData.stationAddress}</td>
                        <td>{ModbusLoraRegister.STATION_ADDRESS}</td>
                    </tr>
                    <tr>
                        <th>Configuración</th>
                        <td>{stationData.stationConfig}</td>
                        <td>{ModbusLoraRegister.STATION_CONFIG}</td>
                    </tr>
                    <tr>
                        <th>Salida 1</th>
                        <td>{stationData.output1}</td>
                        <td>{ModbusLoraRegister.OUTPUT_1}</td>
                    </tr>
                    <tr>
                        <th>Salida 2</th>
                        <td>{stationData.output2}</td>
                        <td>{ModbusLoraRegister.OUTPUT_2}</td>
                    </tr>
                    <tr>
                        <th>Salida 3</th>
                        <td>{stationData.output3}</td>
                        <td>{ModbusLoraRegister.OUTPUT_3}</td>
                    </tr>
                    <tr>
                        <th>Salida 4</th>
                        <td>{stationData.output4}</td>
                        <td>{ModbusLoraRegister.OUTPUT_4}</td>
                    </tr>
                    <tr>
                        <th>Salida 5</th>
                        <td>{stationData.output5}</td>
                        <td>{ModbusLoraRegister.OUTPUT_5}</td>
                    </tr>
                    <tr>
                        <th>Salida 6</th>
                        <td>{stationData.output6}</td>
                        <td>{ModbusLoraRegister.OUTPUT_6}</td>
                    </tr>
                    <tr>
                        <th>Latch Outputs</th>
                        <td>{stationData.latchOutputs}</td>
                        <td>{ModbusLoraRegister.LATCH_OUTPUTS}</td>
                    </tr>
                    <tr>
                        <th>Entradas Digitales</th>
                        <td>{stationData.digitalInputs}</td>
                        <td>{ModbusLoraRegister.DIGITAL_INPUTS}</td>
                    </tr>
                    <tr>
                        <th>Analógica 1</th>
                        <td>{stationData.analogInput1}</td>
                        <td>{ModbusLoraRegister.ANALOG_INPUT_1}</td>
                    </tr>
                    <tr>
                        <th>Analógica 2</th>
                        <td>{stationData.analogInput2}</td>
                        <td>{ModbusLoraRegister.ANALOG_INPUT_2}</td>
                    </tr>
                    <tr>
                        <th>Voltaje Batería</th>
                        <td>{stationData.batteryVoltage}</td>
                        <td>{ModbusLoraRegister.ANALOG_BATTERY_VOLTAGE}</td>
                    </tr>
                    <tr>
                        <th>Contador 1</th>
                        <td>{stationData.counter1}</td>
                        <td>{`${ModbusLoraRegister.COUNTER_1_H} (H), ${ModbusLoraRegister.COUNTER_1_L} (L)`}</td>
                    </tr>
                    <tr>
                        <th>Contador 2</th>
                        <td>{stationData.counter2}</td>
                        <td>{`${ModbusLoraRegister.COUNTER_2_H} (H), ${ModbusLoraRegister.COUNTER_2_L} (L)`}</td>
                    </tr>
                    <tr>
                        <th>Contador 3</th>
                        <td>{stationData.counter3}</td>
                        <td>{`${ModbusLoraRegister.COUNTER_3_H} (H), ${ModbusLoraRegister.COUNTER_3_L} (L)`}</td>
                    </tr>
                    <tr>
                        <th>Contador 4</th>
                        <td>{stationData.counter4}</td>
                        <td>{`${ModbusLoraRegister.COUNTER_4_H} (H), ${ModbusLoraRegister.COUNTER_4_L} (L)`}</td>
                    </tr>
                    <tr>
                        <th>Contador 5</th>
                        <td>{stationData.counter5}</td>
                        <td>{`${ModbusLoraRegister.COUNTER_5_H} (H), ${ModbusLoraRegister.COUNTER_5_L} (L)`}</td>
                    </tr>
                    <tr>
                        <th>Contador 6</th>
                        <td>{stationData.counter6}</td>
                        <td>{`${ModbusLoraRegister.COUNTER_6_H} (H), ${ModbusLoraRegister.COUNTER_6_L} (L)`}</td>
                    </tr>
                    <tr>
                        <th>Parcial 1</th>
                        <td>{stationData.partial1}</td>
                        <td>{ModbusLoraRegister.PARTIAL_COUNTER_1}</td>
                    </tr>
                    <tr>
                        <th>Parcial 2</th>
                        <td>{stationData.partial2}</td>
                        <td>{ModbusLoraRegister.PARTIAL_COUNTER_2}</td>
                    </tr>
                    <tr>
                        <th>Parcial 3</th>
                        <td>{stationData.partial3}</td>
                        <td>{ModbusLoraRegister.PARTIAL_COUNTER_3}</td>
                    </tr>
                    <tr>
                        <th>Parcial 4</th>
                        <td>{stationData.partial4}</td>
                        <td>{ModbusLoraRegister.PARTIAL_COUNTER_4}</td>
                    </tr>
                    <tr>
                        <th>Parcial 5</th>
                        <td>{stationData.partial5}</td>
                        <td>{ModbusLoraRegister.PARTIAL_COUNTER_5}</td>
                    </tr>
                    <tr>
                        <th>Parcial 6</th>
                        <td>{stationData.partial6}</td>
                        <td>{ModbusLoraRegister.PARTIAL_COUNTER_6}</td>
                    </tr>
                    <tr>
                        <th>Temperatura</th>
                        <td>{stationData.temperature}</td>
                        <td>{ModbusLoraRegister.TEMPERATURE}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    }

    render(): React.ReactNode {
        return <IonPage>


            <IonHeader color={"secondary"}>
                <IonToolbar color={"primary"}>
                    <IonButtons slot="start">
                        <IonButton routerDirection={"back"} routerLink={"/device/" + this.props.match.params.id + "/details"} ><IonIcon icon={arrowBack} /></IonButton>
                    </IonButtons>
                    <IonTitle>{this.state.device?.name} - {this.state.output?.name} </IonTitle>

                    <IonButtons slot="end">
                        <IonButton onClick={() => this.updateCommand()}><IonIcon icon={reload} /></IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent scrollEvents={true}>
                {/* {this.state.stationData && this.renderStation(this.state.stationData)} */}


                {this.state.error && <IonText>{this.state.error}</IonText>}
                {this.renderLoading()}

                <h1>Configuracion Estaciones LoRa - Modbus</h1>

                {this.state.stationConfig && <div>
                    <table>
                        <tbody>
                            <tr>
                                <th>Dirección</th>
                                <td>{this.state.stationConfig.stationAddress}</td>
                            </tr>
                            <tr>
                                <th>Configuración</th>
                                <td>{this.state.stationConfig.stationConfig}</td>
                            </tr>
                            <tr>
                                <th>Salidas</th>
                                <td>
                                    {Array.from({ length: 6 }, (_, i) => (
                                        <span key={i}>Salida {i + 1}: {this.state.stationConfig && this.state.stationConfig[`output${i + 1}` as keyof typeof this.state.stationConfig]}&nbsp;&nbsp;</span>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <th>Latch Outputs</th>
                                <td>{this.state.stationConfig.latchOutputs}</td>
                            </tr>
                            <tr>
                                <th>Entradas Digitales</th>
                                <td>{this.state.stationConfig.digitalInputs}</td>
                            </tr>
                            <tr>
                                <th>Entradas Analógicas</th>
                                <td>
                                    Analógica 1: {this.state.stationConfig.analogInput1} &nbsp;
                                    Analógica 2: {this.state.stationConfig.analogInput2}
                                </td>
                            </tr>
                            <tr>
                                <th>Voltaje Batería</th>
                                <td>{this.state.stationConfig.batteryVoltage}</td>
                            </tr>
                            <tr>
                                <th>Contadores</th>
                                <td>
                                    {Array.from({ length: 6 }, (_, i) => (
                                        <span key={i}>Contador {i + 1}: {this.state.stationConfig && this.state.stationConfig[`counter${i + 1}` as keyof typeof this.state.stationConfig]}&nbsp;&nbsp;</span>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <th>Parciales</th>
                                <td>
                                    {Array.from({ length: 6 }, (_, i) => (
                                        <span key={i}>Parcial {i + 1}: {this.state.stationConfig && this.state.stationConfig[`partial${i + 1}` as keyof typeof this.state.stationConfig]}&nbsp;&nbsp;</span>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <th>Temperatura</th>
                                <td>{this.state.stationConfig.temperature}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>}

                {this.state.stationsList && this.state.stationsList.map((station, index) => {
                    return (
                        <div key={index}>
                            <h2>Estación {station.stationId}</h2>
                            <p>Configuración: {station.stationConfig}</p>
                            <p>Dirección: {station.stationAddress}</p>

                            <IonButton onClick={this.handleCargarDatos(station.stationId)}>Cargar Datos Estacion</IonButton>
                            
                            {station.stationData && this.renderStationData(station.stationData)}

                            {/* <IonButton onClick={this.handleCargarEstadisticas}>Cargar Estadisticas Estacion</IonButton> */}
                        </div>
                    );
                })}

            </IonContent>
        </IonPage>
    }
}